import { ListPageLayout } from 'framework/list';
import { ListHeader } from 'framework/list';
import { CreateForm, DateInput, SubmitFormButton } from 'framework/form';
import { LoadingFormLayout, FormRow } from 'framework/ui/layout';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import useLeadReportService from 'domain/sales/report/useLeadReportService';

const DEFAULT_FROM_DATE = '2025-01-01';

const RawLeadDataReportPage = () => {
  const { downloadRawDataReport } = useLeadReportService();
  const { getCurrentDate, formatDate } = useDateService();

  return (
    <ListPageLayout header={<ListHeader label="Raw Lead Data Report" icon="fa-download" />}>
      <CreateForm
        submitFormFunc={data => downloadRawDataReport(data.fromDate, data.toDate)}
        initialData={{
          fromDate: DEFAULT_FROM_DATE,
          toDate: formatDate(getCurrentDate(), DATE_FORMAT.API_ONLY_DATE)?.trim(),
        }}
      >
        <FormRow colXl={3}>
          <DateInput source="fromDate" label="From date" />
          <DateInput source="toDate" label="To date" />
        </FormRow>
        <SubmitFormButton>Download CSV</SubmitFormButton>
        <LoadingFormLayout />
      </CreateForm>
    </ListPageLayout>
  );
};

export default RawLeadDataReportPage;
